const operation = {
  LOGIN: '20',
  TRANSFERENCIA: '02|06',
  CREAR_DESTINATARIO: '07',
  EDITAR_DESTINATARIO: '08',
  DATOS_PERSONALES: '03',
  BLOQUEO_TARJETA_CUENTA_VISTA: '04',
  MANTENEDOR_CUENTA: '11',
  CAMBIO_CLAVE: '12',
  DIRECCION_PARTICULAR: '13',
  DIRECCION_COMERCIAL: '14',
  PAGO_CONSUMO: '15',
  PAGO_HIPOTECARIO: '16',
  FORGOT_PASSWORD: '12',
  PAGO_TARJETA_CREDITO: '17',
  PAGO_CUOTA_PARTICIPACION: '18',
  BLOQUEO_TARJETA_COORDENADAS: '19',
  OTHER: '00',
  DAP_MENOS_5MM: '21',
  DAP_MAYOR_5MM: '22',
  DAP_LIQUIDAR_MENOR_5MM: '23',
  DAP_LIQUIDAR_MAYOR_5MM: '24',
};

export default operation;
